import React from 'react'
import PropTypes from 'prop-types'

// Phone
const PhoneNumber = ({ children: full }) => {
  if (!full) return ''
  const DDD = full.substr(0, 2)
  const numberFH = full.substr(2, 4)
  const numberSH = full.substr(6)
  return <span>({DDD}) {numberFH}-{numberSH}</span>
}
PhoneNumber.propTypes = {
  children: PropTypes.string,
}

// CPF
const CPF = ({ children: full }) => {
  if (!full) return ''
  const p1 = full.substr(0, 3)
  const p2 = full.substr(3, 3)
  const p3 = full.substr(6, 3)
  const p4 = full.substr(-2)
  return <span>{p1}.{p2}.{p3}-{p4}</span>
}
CPF.propTypes = {
  children: PropTypes.string,
}

const Currency = ({ children: full }) => {
  if (!full) return ''
  const number = parseFloat(full).toFixed(2)
  return <span>R$ {number}</span>
}

export { PhoneNumber, CPF, Currency }



// WEBPACK FOOTER //
// ./src/components/Formatter/index.js